import { inject, Injectable, OnDestroy } from '@angular/core';
import { CardDraft } from '@shared/api/api-loop/models/card-draft';
import { ConversationsActionService } from '@shared/modules/conversations/services/conversations-action.service';
import { Observable, startWith, Subject } from 'rxjs';
import { CommentDraftModel } from '@dta/shared/models-api-loop/comment/comment.model';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';
import {
  ConversationModel,
  isConversationModel
} from '@dta/shared/models-api-loop/conversation-card/conversation/conversation.model';
import { BaseModel } from '@dta/shared/models-api-loop/base/base.model';

@Injectable()
export class CommentIframeActionsService implements OnDestroy {
  private readonly conversationsActionService: ConversationsActionService = inject(ConversationsActionService);

  readonly draftUpdated$: Subject<CommentDraftModel> = new Subject<CommentDraftModel>();

  observeDraftUpdate$(draftCard?: CardDraft): Observable<void> {
    return this.draftUpdated$.pipe(
      filter(draftComment => !!draftCard && draftComment.parent?.id === draftCard.id),
      startWith(!!draftCard),
      filter(isDraftUpdate => !!isDraftUpdate),
      map(() => undefined)
    );
  }

  observeDraftDelete$(conversationId: string): Observable<void> {
    return this.conversationsActionService.conversationsUpdated$.pipe(
      map(conversations =>
        conversations.find(conversation => [conversationId, `${conversationId}-copy1T`].includes(conversation.cardId))
      ),
      filter(conversation => !!conversation),
      filter((model: BaseModel): model is ConversationModel => isConversationModel(model)),
      distinctUntilChanged((prevConversation, currConversation) => {
        return prevConversation.draftTypes.length === currConversation.draftTypes.length;
      }),
      filter(conversation => conversation.draftTypes.length === 0),
      map(() => undefined)
    );
  }

  ngOnDestroy(): void {
    this.draftUpdated$.complete();
  }
}
